import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

// Define props for the styled component
interface RootProps {
  isMobile?: boolean;
}

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<RootProps>(({ isMobile }) => ({
  width: "100%",
  backgroundImage: "url(/img/login-background.png)",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: isMobile ? "auto" : "100vh",
}));
